// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/spriteicons.css
// module id = 307
// module chunks = 0